import { CALL_API } from 'redux-api-middleware'
import { 
  SAVE_HISTORY_CHAT_REQUEST,
  SAVE_HISTORY_CHAT_SUCCESS,
  SAVE_HISTORY_CHAT_FAILURE,
  LOAD_LIVEDETAIL_REQUEST,
  LOAD_LIVEDETAIL_SUCCESS,
  LOAD_LIVEDETAIL_FAILURE,
  LOAD_REVIEWLIVE_REQUEST,
  LOAD_REVIEWLIVE_SUCCESS,
  LOAD_REVIEWLIVE_FAILURE,
  LOAD_CATEGORYCREATOR_REQUEST,
  LOAD_CATEGORYCREATOR_SUCCESS,
  LOAD_CATEGORYCREATOR_FAILURE,
} from './types'
// import { replace } from 'react-router-redux'
import { token } from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const setHistoryChat = data => ({
  type: SAVE_HISTORY_CHAT_SUCCESS,
  data,
})
export const loadHistoryChat = (endpoint) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'GET',
        headers,
        types: [
          SAVE_HISTORY_CHAT_REQUEST,
          SAVE_HISTORY_CHAT_SUCCESS,
          SAVE_HISTORY_CHAT_FAILURE,
        ],
      },
    })
  }
}
export const loadLiveDetailPage = (endpoint, id) => {
  const form = new FormData()
  form.append('id', id)
  // form.append('idCoin', null)
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        headers,
        body: form,
        types: [
          LOAD_LIVEDETAIL_REQUEST,
          // {
          //   type: LOAD_COURSE_PAGES_SUCCESS,
          //   payload: async (action, state, res) => {
          //     const response = await res.json()
          //     dispatch({
          //       type: LOAD_PLAYLISTS_PLAYER,
          //       data: response,
          //     })
          //     return response
          //   },
          // },
          LOAD_LIVEDETAIL_SUCCESS,
          LOAD_LIVEDETAIL_FAILURE,
        ],
      },
    })
  }
}
export const loadReviewLivePage = (endpoint) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'GET',
        headers,
        types: [
          LOAD_REVIEWLIVE_REQUEST,
          LOAD_REVIEWLIVE_SUCCESS,
          LOAD_REVIEWLIVE_FAILURE,
        ],
      },
    })
  }
}
export const loadCategoryCreator = (endpoint) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'GET',
        headers,
        types: [
          LOAD_CATEGORYCREATOR_REQUEST,
          LOAD_CATEGORYCREATOR_SUCCESS,
          LOAD_CATEGORYCREATOR_FAILURE,
        ],
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/live.js